export default "__VITE_ASSET__JFFx8u8u__"